export default __webpack_public_path__ + "cc3e740775933f5d8e3ceb7689a2e0d0.svg";